module.exports = __webpack_public_path__ + "img/9 filters-09.f9ebf344.svg";